import { clientContactDetailsStore } from './features/client-contact-details/client-contact-details.store';
import { newClientContactStore } from '../client-contacts/features/new-client-contact/new-client-contact.store';
import { ClientContactListingStore } from './features/client-contact-listing/client-contacts-listing.store';
export const clientContactsStore = {
  modules: {
    newClientContactState: newClientContactStore,
    clientContactDetailsState: clientContactDetailsStore,
    clientContactListingState: ClientContactListingStore
  }
};
